import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from '@angular/forms';

import {ParametroFuncao} from 'src/app/funcao/models/parametro-funcao';
import {OpcoesParametros} from "../../regra/cadastro-regra/parametro-funcao/opcoes-parametros";
import {HttpClient} from "@angular/common/http";
import {getBackHost} from "../../util/server-util";

@Component({
    selector: 'maps-checkbox',
    templateUrl: './maps-checkbox.component.html',
    styleUrls: ['./maps-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapsCheckboxComponent implements AfterViewInit, OnInit {

    @Input() schemaPai: ParametroFuncao = {
        descricao: "",
        endpointOpcoes: "",
        label: "",
        obrigatorio: false,
        ordem: 0,
        parametroVinculado: "",
        parametros: [],
        tamanhoMaximoExibicao: 0,
        tipo: undefined,
        variavel: ""
    };
    @Input() schema: ParametroFuncao = {
        descricao: "",
        endpointOpcoes: "",
        label: "",
        obrigatorio: false,
        ordem: 0,
        parametroVinculado: "",
        parametros: [],
        tamanhoMaximoExibicao: 0,
        tipo: undefined,
        variavel: ""
    };
    @Input() formGroup: FormGroup = new FormGroup({});
    @Input() readonly = false;
    @Input() parametrosRegra;

    public formControl: AbstractControl;
    public required: boolean;

    allChecked = false;
    opcoes: OpcoesParametros[] = [];
    checkboxControls: FormArray = new FormArray([]);
    hiddenControl: FormControl;
    itemValue: any = null;
    selectedOptions: string [] = [];
    touched = false;

    constructor(
        private readonly httpclient: HttpClient,
        private readonly changeDetector: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        let validator = null;

        if (this.schema.obrigatorio) {
            validator = Validators.required;
        }

        this.formControl = new FormArray([]);
        this.checkboxControls = this.formControl as FormArray;

        this.hiddenControl = new FormControl(this.mapItems(this.checkboxControls.value), validator);
        this.formGroup.addControl(this.schema.variavel, this.hiddenControl);
        this.checkboxControls.valueChanges.subscribe((checkbox => this.hiddenControl.setValue(this.mapItems(checkbox))));
    }

    ngAfterViewInit(): void {
        this.httpclient.get<OpcoesParametros[]>(getBackHost(this.schema.endpointOpcoes)).subscribe(opcoes => {
            this.opcoes = opcoes;

            this.opcoes.forEach((item) => {
                let check;
                check = new FormControl();

                if (this.schemaPai && this.parametrosRegra
                    && this.parametrosRegra[this.schemaPai.variavel]
                    && this.schema.variavel in this.parametrosRegra[this.schemaPai.variavel]) {
                    let parametrosRegraElement = this.parametrosRegra[this.schemaPai.variavel];
                    if (parametrosRegraElement[this.schema.variavel]?.includes(item.key)) {
                        check.setValue(item.key);
                        this.selectedOptions.push(item.key);
                    }
                } else if (this.parametrosRegra && this.parametrosRegra[this.schema.variavel]?.includes(item.key)) {
                    check.setValue(item.key);
                    this.selectedOptions.push(item.key);
                }

                this.checkboxControls.push(check);
            });

            if (this.readonly) {
                this.formControl.disable();
            }

            this.allChecked = (this.selectedOptions.length === this.opcoes.length);

            this.changeDetector.detectChanges();
        });
    }

    private mapItems(value: any) {
        if (value) {
            value = value.filter(item => item ? item : false);
            return value.length ? value : null;
        } else {
            return null;
        }
    }

    selectAll(checked: boolean) {
        this.touched = true;
        this.selectedOptions = [];
        this.opcoes.forEach((opcao, index) => {
            if (checked) {
                this.checkboxControls.controls[index].patchValue(opcao.key);
                this.selectedOptions.push(opcao.key);
            } else {
                this.checkboxControls.controls[index].patchValue(null);
                this.selectedOptions.splice(index, 1);
            }
        });
    }

    checkboxChange(checked: boolean, value: string, formIndex: number) {
        this.touched = true;
        if (checked === true) {
            this.selectedOptions.push(value);
            const control = this.checkboxControls.controls[formIndex] as FormControl;
            control.setValue(value);
        } else {
            const index: number = this.selectedOptions.indexOf(value);
            const control = this.checkboxControls.controls[formIndex] as FormControl;
            control.setValue(null);
            this.selectedOptions.splice(index, 1);
        }

        this.updateAllChecked();
    }

    updateAllChecked() {
        this.changeDetector.detectChanges();
    }
}
